import React from 'react'
import { ObjectDetailsWrapperProps } from '../ObjectDetails'
import { FloorNumber } from '../fields/floorNumber/FloorNumber'
import { TotalFloors } from '../fields/totalFloors/TotalFloors'
import HeatingTypeField from '../../commonFields/heatingType/HeatingTypeField'
import ConstructionConditionField from '../../construction/fields/constructionConditionField/ConstructionConditionField'
import MaxNumberOfPersons from '../fields/maxNumberOfPersons/MaxNumberOfPersons'
import MinRentalTime from '../fields/minRentalTime/MinRentalTime'
import MaxRentalTime from '../fields/maxRentalTime/MaxRentalTime'

export const floorNumberField =
  (wrapperClassName?: string, labelTranslationKey?: string, showMandatory = false) =>
  (props: ObjectDetailsWrapperProps) => (
    <FloorNumber
      {...props}
      wrapperClassName={wrapperClassName}
      labelTranslationKey={labelTranslationKey}
      showMandatory={showMandatory}
    />
  )

export const totalFloorsField =
  (wrapperClassName?: string, labelTranslationKey?: string, popoverLabelTranslationKey?: string) =>
  (props: ObjectDetailsWrapperProps) => (
    <TotalFloors
      {...props}
      wrapperClassName={wrapperClassName}
      labelTranslationKey={labelTranslationKey}
      popoverLabelTranslationKey={popoverLabelTranslationKey}
    />
  )

export const objectConditionField = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <ConstructionConditionField {...props} wrapperClassName={wrapperClassName} />
)

export const heatingTypeField = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <HeatingTypeField {...props} wrapperClassName={wrapperClassName} />
)

export const maxNumberOfPersons = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <MaxNumberOfPersons {...props} wrapperClassName={wrapperClassName} />
)

export const minRentalTime = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <MinRentalTime {...props} wrapperClassName={wrapperClassName} />
)

export const maxRentalTime = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <MaxRentalTime {...props} wrapperClassName={wrapperClassName} />
)
